export default __webpack_public_path__ + "static/media/place-4.2b674efb.jpg";